(function($) {

    function AdsOwl(element, options) {
        if(element || options ) { true; } // this is here because of linting rules; remove at your own risk.
        $.fn.owlCarousel.Constructor.apply(this, arguments);
    }

    AdsOwl.prototype  = Object.create($.fn.owlCarousel.Constructor.prototype);
    AdsOwl.prototype.constructor = AdsOwl;

    //Override carousel navigation method 'to'
    var superOwlCarouselMethodTo = AdsOwl.prototype.to;
    AdsOwl.prototype.to = function(position, speed) {
        if (position < 0) {
            //reverse loop from first to last without using cloned node
            var items = this._items.length;
            var current = items + 2;

            position = items + 1;
            this.reset(current);

            this.speed(this.duration(current, position, speed));
            this.current(position);

            if (this.$element.is(':visible')) {
                this.update();
            }
        } else {
            superOwlCarouselMethodTo.apply(this, arguments);
        }
    };

    var superOwlCarouselMethodUpdate = AdsOwl.prototype.update;
    AdsOwl.prototype.update = function() {
        superOwlCarouselMethodUpdate.apply(this, arguments);

        var clonedItems = this.$element.find('.owl-item.cloned .item');

        $(clonedItems).remove();
    };

    $.fn.adsOwlCarousel = function(option) {
        var args = Array.prototype.slice.call(arguments, 1);
        var Owl = $.fn.owlCarousel.Constructor;

        return this.each(function() {
            var $this = $(this),
                data = $this.data('owl.carousel');

            if (!data) {
                data = new AdsOwl(this, typeof option == 'object' && option);
                $this.data('owl.carousel', data);

                $.each([
                    'next', 'prev', 'to', 'destroy', 'refresh', 'replace', 'add', 'remove'
                ], function(i, event) {
                    data.register({ type: Owl.Type.Event, name: event });
                    data.$element.on(event + '.owl.carousel.core', $.proxy(function(e) {
                        if (e.namespace && e.relatedTarget !== this) {
                            this.suppress([ event ]);
                            data[event].apply(this, [].slice.call(arguments, 1));
                            this.release([ event ]);
                        }
                    }, data));
                });
            }
            if (typeof option == 'string' && option.charAt(0) !== '_') {
                data[option].apply(data, args);
            }
        });
    };

})(window.jQuery);



//////////////////
// WEBPACK FOOTER
// ./src/interlock/ui/owl-carousel/ads-owl-carousel.js
// module id = 37
// module chunks = 0 1 2 3 4 5 6 7 8 10 11 12 13 14 15 17